import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";

/**
 * EmptyState - Shared empty-state layout for session tabs (Agenda, Action Items).
 * Renders an illustration, a descriptive message, and a primary call-to-action.
 */
const EmptyState = ({ image, message, action }) => (
  <Box spacingInset="450 none none none">
    <Column spacing="none">
      <Box spacingInset="none 450 none 450">
        <Column spacing="400">
          <img src={image} alt="" width="72" height="72" />
          <Text type="b100" color="secondary">{message}</Text>
        </Column>
      </Box>
      <Box spacingInset="400 none none 450">{action}</Box>
    </Column>
  </Box>
);

export default EmptyState;
